import { Component } from '@angular/core';
import { HomeApiService } from '../../services/home-api.service';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import { ActivatedRoute, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AttachmentService } from '../../../../common/service/attachment.service';
import { FileSaverService } from 'ngx-filesaver';
import { CompatibilityGuidelinesService } from '../../../backoffice/service/compatibility-guidelines.service';
import { CommonService } from '../../../../common/service/common.service';
import { HelpService } from '../../../backoffice/service/help.services';

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent {
  filterId: string = 'CSMRT_HomePage_1';
  data: any = { data: [], total: 0 };
  selectedTab: string = "Product_Variant";
  placeHolders: any = {
    "Product_Variant": "Search Product Variant or Technical Name",
    "Raw_Material": "Search Generic Group or Technical Name",
    "Generic_Group": "Search Generic Group or Technical Name",

  }

  manufacturingPlants: any = [];

  warehouseLocations: any = [];

  startDate: Date | null = new Date();
  endDate: Date | null = new Date();
  advancedFilter: any;
  searchStringForQuery: any;
  searchText: any;
  viewType: string = 'All';
  advanceFilterDto: any;

  isContainsPlants: boolean = false;
  selectedManufacturingPlants: any = [];
  selectedFileWarehouseLocations: any = [];

  pageSize: number = 30;
  pageStartIndex: number = 0;
  pageStartIndex_productVariant: number = 0;
  pageStartIndex_rawMaterial: number = 0;
  pageStartIndex_genericGroup: number = 0;

  orderBy_Direction: any =  [{ orderBy: 'lastModifiedDate', orderDirection: 'desc' }]; //'ASC
  orderBy_Direction_productVariant: any =  [];
  orderBy_Direction_rawMaterial: any =  [];
  orderBy_Direction_genericGroup: any =  [];

  lodingLable = '';

  compGuidelinesList: any = null;


  data_productVariant: any = { data: [], total: 0 };
  data_rawMaterial: any = { data: [], total: 0 };
  data_genericGroup: any = { data: [], total: 0 };

  isAdvancedFilter: boolean = false;


  constructor(private homeApiService: HomeApiService,
    private router: Router,
    private fileSaverService: FileSaverService,
    private compGuidelinesService: CompatibilityGuidelinesService,
    private helpService: HelpService,
    private route: ActivatedRoute
  ) { 

    this.orderBy_Direction = localStorage.getItem("orderBy_Direction_CSMRT_HomePage_1" ) ? JSON.parse(localStorage.getItem('orderBy_Direction_CSMRT_HomePage_1') || '[]') : [{ orderBy: 'lastModifiedDate', orderDirection: 'desc' }];
    this.orderBy_Direction_productVariant = localStorage.getItem("orderBy_Direction_CSMRT_HomePage_1") ? JSON.parse(localStorage.getItem("orderBy_Direction_CSMRT_HomePage_1") || '[]') : [{ field: 'lastModifiedDate', dir: 'desc' }];
    this.orderBy_Direction_rawMaterial = localStorage.getItem("orderBy_Direction_CSMRT_HomePage_2") ? JSON.parse(localStorage.getItem("orderBy_Direction_CSMRT_HomePage_2") || '[]') : [{ field: 'lastModifiedDate', dir: 'desc' }];
    this.orderBy_Direction_genericGroup = localStorage.getItem("orderBy_Direction_CSMRT_HomePage_3") ? JSON.parse(localStorage.getItem("orderBy_Direction_CSMRT_HomePage_3") || '[]') : [{ field: 'lastModifiedDate', dir: 'desc' }];

  }

  ngOnInit() {
    let CSMRT_HomePage_filter: any = localStorage.getItem('CSMRT_HomePage_1');
    this.route.queryParams.subscribe(params => {
      const selectedTab = params['selectedTab'];
      if (selectedTab==1) {
        this.selectedTab = 'Product_Variant';
        this.orderBy_Direction_productVariant = localStorage.getItem("orderBy_Direction_CSMRT_HomePage_1") ? JSON.parse(localStorage.getItem("orderBy_Direction_CSMRT_HomePage_1") || '[]') : [{ field: 'lastModifiedDate', dir: 'desc' }];
      }
      else if (selectedTab==2) {
        this.selectedTab = 'Raw_Material';
        CSMRT_HomePage_filter = localStorage.getItem('CSMRT_HomePage_2') ;
        this.orderBy_Direction_rawMaterial = localStorage.getItem("orderBy_Direction_CSMRT_HomePage_2") ? JSON.parse(localStorage.getItem("orderBy_Direction_CSMRT_HomePage_2") || '[]') : [{ field: 'lastModifiedDate', dir: 'desc' }];
      }
      else if (selectedTab==3) {
        this.selectedTab = 'Generic_Group';
        CSMRT_HomePage_filter = localStorage.getItem('CSMRT_HomePage_3')
        this.orderBy_Direction_genericGroup = localStorage.getItem("orderBy_Direction_CSMRT_HomePage_3") ? JSON.parse(localStorage.getItem("orderBy_Direction_CSMRT_HomePage_3") || '[]') : [{ field: 'lastModifiedDate', dir: 'desc' }];
      }
      
      if(CSMRT_HomePage_filter)
        this.filterCustomData(JSON.parse( CSMRT_HomePage_filter));
      // else
      
      this.getDropDownPlantsAndWarehouse();

      this.GetLastUploaded();
      this.tabChange(this.selectedTab);
    });
  }

  navigateTo(url: string, queryParams: any = null) {
    this.router.navigate([url], { queryParams: queryParams });
  }

  ClickToView(type: string = 'All') {
    let sDate = new Date();
    let eDate = new Date();

    if (type == 'All') {
      this.startDate = null;
      this.endDate = null;
    } else if (type == 'Last7days') {

      sDate.setDate(sDate.getDate() - 7);
      eDate.setDate(eDate.getDate() - 1);

      this.startDate = sDate;
      this.endDate = eDate;

    }
  }

  oldAdvanceFilterResponse: any = null;
  isAdvancedFilterOpened:boolean=false;
  filterCustomData(event: any) {
    this.isAdvancedFilter = true;

    this.oldAdvanceFilterResponse = event;
    this.advanceFilterDto = event.filterEvent?.advanceFilterDto;

    this.advancedFilter = event.filterEvent?.advanceFilterResponse?.searchString;
    this.searchStringForQuery = event.filterEvent?.advanceFilterResponse?.searchStringForQuery;
    this.searchText = event.searchValue;
    this.isAdvancedFilterOpened = event.isAdvancedFilterOpened;
    this.isContainsPlants = event.isContainsPlants;
    this.selectedManufacturingPlants = event.selectedManufacturingPlants;
    this.selectedFileWarehouseLocations = event.selectedFileWarehouseLocations;

    this.getMaterialDetails();
  }

  getDropDownPlantsAndWarehouse() {
    this.homeApiService.getDropDownPlantsAndWarehouse({preventLoader:true}).subscribe((res: any) => {
      if (res) {
        this.manufacturingPlants = ['(No Plants)',...(res.manufacturingPlants || [])];
        this.warehouseLocations = ['(No Locations)', ...(res.warehouseLocations || [])];
      }
    }
    )
  }

  getMaterialDetails() {

    let pageStartIndex = this.pageStartIndex ? this.pageStartIndex : 0;
    let orderBy_Direction = this.orderBy_Direction[0];
    if (this.selectedTab == 'Product_Variant') {
      pageStartIndex = this.pageStartIndex_productVariant ? this.pageStartIndex_productVariant : 0;
      orderBy_Direction = this.orderBy_Direction_productVariant[0];
    } else if (this.selectedTab == 'Raw_Material') {
      pageStartIndex = this.pageStartIndex_rawMaterial ? this.pageStartIndex_rawMaterial : 0;
      orderBy_Direction = this.orderBy_Direction_rawMaterial[0];
    } else if (this.selectedTab == 'Generic_Group') {
      pageStartIndex = this.pageStartIndex_genericGroup ? this.pageStartIndex_genericGroup : 0;
      orderBy_Direction = this.orderBy_Direction_genericGroup[0];
    }
    if (this.selectedTab == 'Product_Variant') {
      this.lodingLable = 'Loading Product Variants...'
    }
    else if (this.selectedTab == 'Raw_Material') {
      this.lodingLable = 'Loading Raw Materials...'
    }
    else if (this.selectedTab == 'Generic_Group') {
      this.lodingLable = 'Loading Generic Groups...'
    }

    let isAllSelected = false;

    if(
      ((this.selectedManufacturingPlants?.length == this.manufacturingPlants?.length) 
      && 
      (this.selectedFileWarehouseLocations?.length == this.warehouseLocations?.length))
      || this.isAdvancedFilterOpened == false
     ){
      isAllSelected = true;
    }

    
    let params = {
      searchTerm: this.searchText || '',
      plantNames:  this.selectedManufacturingPlants?.length  ? this.selectedManufacturingPlants?.map((data: any) => data.value) : [],
      warehouseNames: this.selectedFileWarehouseLocations?.length  ? this.selectedFileWarehouseLocations?.map((data: any) => data.value) : [],
      isContainsPlants: !this.isAdvancedFilterOpened? false : this.isContainsPlants,
      advancedFilter: '',//this.advancedFilter,
      dateFilterOption: this.viewType,
      pageStartIndex: pageStartIndex,
      pageSize: this.pageSize,
      materialType: this.selectedTab == 'Product_Variant' ? 'productvariant' : this.selectedTab == 'Raw_Material' ? 'rawmaterial' : 'genericgroup',

      advanceFilterDto: this.advanceFilterDto ? this.advanceFilterDto : null,

      orderBy: orderBy_Direction?.field || 'LastModifiedDate',
      orderDirection: (orderBy_Direction?.dir || 'DESC').toUpperCase(),

      IsAllSelected: isAllSelected

      // searchParameters
    }
    // {dir: 'asc', field: 'technicalName'}
    this.homeApiService.getMaterialDetails(params).subscribe((res: any) => {
      if (res) {

        res.results = res.results.map((item: any) => {
          item.materialCodeDetails = item.materialCodeDetails?.split('|').join('<br/> ') || '';
          return item;
        });

        this.lodingLable = ''
        this.data = { data: res.results, total: res.totalCount };

        if (this.selectedTab == 'Product_Variant') {
          this.data_productVariant = { data: res.results, total: res.totalCount };
        } else if (this.selectedTab == 'Raw_Material') {
          this.data_rawMaterial = { data: res.results, total: res.totalCount };
        } else if (this.selectedTab == 'Generic_Group') {
          this.data_genericGroup = { data: res.results, total: res.totalCount };
        }
      }
    }, error => {
      console.error('Error fetching material details:', error?.error || error);
      this.lodingLable = '';
      this.data = { data: [], total: 0 };
    }
  )
  }
  viewTypeChange(type: string) {
    this.viewType = type;
    this.getMaterialDetails();
  }
  onSortChange(event: any) { 
    this.pageStartIndex = 0;
    let tmpSort:any=[];
    if(event[0].dir) {
      this.orderBy_Direction = event;
      tmpSort=event
    }
    else{
      this.orderBy_Direction = [];
      tmpSort=[{ field: 'lastModifiedDate', dir: 'desc' }]
    }
    if(this.selectedTab == 'Product_Variant') {
      this.orderBy_Direction_productVariant = tmpSort;
    } else if(this.selectedTab == 'Raw_Material') {
      this.orderBy_Direction_rawMaterial = tmpSort;
    } else if(this.selectedTab == 'Generic_Group') {
      this.orderBy_Direction_genericGroup = tmpSort;
    }

    this.getMaterialDetails();

  }
  tabChange(tab: any) {

    this.selectedTab = tab;

    if (tab == 'Product_Variant') {
      this.filterId = 'CSMRT_HomePage_1';
      this.pageStartIndex = this.pageStartIndex_productVariant ? this.pageStartIndex_productVariant : 0;
      this.orderBy_Direction = this.orderBy_Direction_productVariant;
    } else if (tab == 'Raw_Material') {
      this.filterId = 'CSMRT_HomePage_2';
      this.pageStartIndex = this.pageStartIndex_rawMaterial ? this.pageStartIndex_rawMaterial : 0;
      this.orderBy_Direction = this.orderBy_Direction_rawMaterial;
    } else if (tab == 'Generic_Group') {
      this.filterId = 'CSMRT_HomePage_3';
      this.pageStartIndex = this.pageStartIndex_genericGroup ? this.pageStartIndex_genericGroup : 0;
      this.orderBy_Direction = this.orderBy_Direction_genericGroup;
    }

    this.searchText = null;
    this.advancedFilter = null;
    this.searchStringForQuery = null;
    
    let CSMRT_HomePage_filter:any = localStorage.getItem(this.filterId) || null;
    if(CSMRT_HomePage_filter)
      this.filterCustomData(JSON.parse( CSMRT_HomePage_filter));
    else{
      this.advanceFilterDto = null;
      this.getMaterialDetails();
    }

  }


  public pageChange({ skip, take }: PageChangeEvent): void {
    this.pageStartIndex = skip;
    if (this.selectedTab == 'Product_Variant') {
      this.pageStartIndex_productVariant = skip;
    } else if (this.selectedTab == 'Raw_Material') {
      this.pageStartIndex_rawMaterial = skip;
    }
    else if (this.selectedTab == 'Generic_Group') {
      this.pageStartIndex_genericGroup = skip;
    }
    this.getMaterialDetails();
  }


  GetLastUploaded() {
    this.compGuidelinesService.GetLastUploaded({preventLoader: true}).subscribe({
      next: (response: any) => {
        this.compGuidelinesList = response;
      },
      error: (err: any) => {
      }
    })
  }
 
  getAttachments() {
    let object: any = this.compGuidelinesList;

    this.helpService.downloadAttachments(object.blobURI).subscribe({
      next: (response: any) => {
        let fileName = object.fileName;
        if (response) {
          this.fileSaverService.save(response, fileName);
        }
      },
      error: (err: any) => {
      }
    })
  }
}
